import styled, { AnyStyledComponent } from 'styled-components';
import FONTS from '../../style/fonts';
import {
    StrikeZoneSvgProps,
    StrikeZoneGProps,
    StrikeZoneRectProps,
    StrikeZoneTextProps,
    StrikeZonePathProps,
} from './strikeZone.types';

export const StrikeZoneSvg: AnyStyledComponent = styled.svg<StrikeZoneSvgProps>`
    display: block;
    ${({ $width }) => $width && `width: ${$width}`};
    &:focus {
        ${({ $selectable }) => $selectable && 'outline: none;'};
    }
`;

export const StrikeZoneRect: AnyStyledComponent = styled.rect<StrikeZoneRectProps>`
    ${({ $fillColor }) => $fillColor && `fill: ${$fillColor}`};
    ${({ $strokeColor }) => $strokeColor && `stroke: ${$strokeColor}`};
    ${({ $strokeWidth }) => $strokeWidth && `stroke-width: ${$strokeWidth}`};
    ${({ $width }) => $width && `width: ${$width}px`};
    ${({ $height }) => $height && `height: ${$height}px`};
    ${({ $transform }) => $transform && `transform: ${$transform}`};
`;

export const StrikeZoneText: AnyStyledComponent = styled.text<StrikeZoneTextProps>`
    ${({ $fillColor }) => $fillColor && `fill: ${$fillColor}`};
    font-family: ${FONTS.primaryFont};
    font-size: 13px;
    font-weight: bold;
    letter-spacing: 0.173333333;
    ${({ $transform }) => $transform && `transform: ${$transform}`};
    ${({ $dominantBaseline }) => $dominantBaseline && `dominant-baseline: ${$dominantBaseline}`};
    ${({ $textAnchor }) => $textAnchor && `text-anchor: ${$textAnchor}`};
`;

export const StrikeZoneG: AnyStyledComponent = styled.g<StrikeZoneGProps>`
    ${({ $fillColor }) => $fillColor && `fill: ${$fillColor}`};
    ${({ $fillRule }) => $fillRule && `fill-rule: ${$fillRule}`};
    ${({ $strokeColor }) => $strokeColor && `stroke: ${$strokeColor}`};
    ${({ $strokeWidth }) => $strokeWidth && `stroke-width: ${$strokeWidth}`};
    ${({ $transform }) => $transform && `transform: ${$transform}`};
    ${({ $selectable }) => $selectable && 'cursor: pointer'};
    &:focus {
        outline: none;
        ${StrikeZoneRect} {
            ${({ $selectable, $focusFillColor }) => $selectable && $focusFillColor && `fill: ${$focusFillColor}`};
        }
        ${StrikeZoneText} {
            ${({ $selectable, $focusStrokeColor }) => $selectable && $focusStrokeColor && `fill: ${$focusStrokeColor}`};
        }
    }
`;

export const StrikeZonePath: AnyStyledComponent = styled.path<StrikeZonePathProps>`
    ${({ $fillColor }) => $fillColor && `fill: ${$fillColor}`};
    ${({ $width }) => $width && `width: ${$width}px`};
    ${({ $height }) => $height && `height: ${$height}px`};
    ${({ $transform }) => $transform && `transform: ${$transform}`};
`;
